export const GH_CLIENT_ID = String(import.meta.env.VITE_GH_CLIENT_ID);
export const GL_CLIENT_ID = String(import.meta.env.VITE_GL_CLIENT_ID);
export const BB_CLIENT_ID = String(import.meta.env.VITE_BB_CLIENT_ID);
export const AZ_CLIENT_ID = String(import.meta.env.VITE_AZ_CLIENT_ID);
export const OAUTH_REDIRECT_URI = String(
  import.meta.env.VITE_OAUTH_REDIRECT_URI
);

export const PADDLE_SANDBOX: boolean =
  import.meta.env.VITE_PADDLE_SANDBOX === 'true';
export const PADDLE_CLIENT_TOKEN = String(
  import.meta.env.VITE_PADDLE_CLIENT_TOKEN
);

export const PADDLE_PERSONAL_PRODUCT = String(
  import.meta.env.VITE_PADDLE_PERSONAL_PRODUCT
);
export const PADDLE_PERSONAL_PRODUCT_MONTHLY = String(
  import.meta.env.VITE_PADDLE_PERSONAL_PRODUCT_MONTHLY
);
export const PADDLE_PERSONAL_PRODUCT_ANNUAL = String(
  import.meta.env.VITE_PADDLE_PERSONAL_PRODUCT_ANNUAL
);

export const PADDLE_TEAM_PRODUCT = String(
  import.meta.env.VITE_PADDLE_TEAM_PRODUCT
);
export const PADDLE_TEAM_PRODUCT_MONTHLY = String(
  import.meta.env.VITE_PADDLE_TEAM_PRODUCT_MONTHLY
);
export const PADDLE_TEAM_PRODUCT_MONTHLY_ADDITIONAL = String(
  import.meta.env.VITE_PADDLE_TEAM_PRODUCT_MONTHLY_ADDITIONAL
);
export const PADDLE_TEAM_PRODUCT_ANNUAL = String(
  import.meta.env.VITE_PADDLE_TEAM_PRODUCT_ANNUAL
);
export const PADDLE_TEAM_PRODUCT_ANNUAL_ADDITIONAL = String(
  import.meta.env.VITE_PADDLE_TEAM_PRODUCT_ANNUAL_ADDITIONAL
);

export const PADDLE_ENTERPRISE_PRODUCT = String(
  import.meta.env.VITE_PADDLE_ENTERPRISE_PRODUCT
);
export const PADDLE_ENTERPRISE_PRODUCT_MONTHLY = String(
  import.meta.env.VITE_PADDLE_ENTERPRISE_PRODUCT_MONTHLY
);
export const PADDLE_ENTERPRISE_PRODUCT_MONTHLY_ADDITIONAL = String(
  import.meta.env.VITE_PADDLE_ENTERPRISE_PRODUCT_MONTHLY_ADDITIONAL
);
export const PADDLE_ENTERPRISE_PRODUCT_ANNUAL = String(
  import.meta.env.VITE_PADDLE_ENTERPRISE_PRODUCT_ANNUAL
);
export const PADDLE_ENTERPRISE_PRODUCT_ANNUAL_ADDITIONAL = String(
  import.meta.env.VITE_PADDLE_ENTERPRISE_PRODUCT_ANNUAL_ADDITIONAL
);
